﻿/* 
Object:         chart
Description:    Logic and events for the module chart
Used in:        chart
*/

window.chart = function () {

    function makePlotLine(valAxName, e, plotband) {
        if (valAxName != undefined &&
            e != undefined &&
            e.sender != undefined &&
            plotband != undefined) {

            var valueAxis = e.sender.getAxis(valAxName);                                     // the axis is found by its name
            if (valueAxis == undefined) return;

            var valueSlot = valueAxis.slot(plotband.from);                                   // the value where the plotline will be drawn
            if (valueSlot == undefined) return;

            var categoryAxis = e.sender.getAxis(e.sender.options.categoryAxis.name);
            if (categoryAxis == undefined) return;

            var lastCategoryIndex = Math.max(1, categoryAxis.range().max);
            if (lastCategoryIndex == undefined) return;

            var maxCategorySlot = categoryAxis.slot(lastCategoryIndex);
            if (maxCategorySlot == undefined) return;

            var line = new kendo.drawing.Path({
                stroke: {
                    color: plotband.color,            // stroke color
                    opacity: 1,                                                         // stroke opacity (1 = totally opague, 0 = transparent)
                    width: 1                                                            // stroke width in pixels
                }
            });

            line.moveTo(valueSlot.origin).lineTo([maxCategorySlot.origin.x, valueSlot.origin.y]);

            var group = new kendo.drawing.Group();
            group.append(line);

            //// Draw on chart surface
            ////
            //// http://docs.telerik.com/kendo-ui/framework/drawing/overview
            e.sender.surface.draw(group);
        }
    }


    ///
    /// Render plotbands if near any of the min/max values (samples) or setting min/max chart (design).
    ///
    function printPlotLines(base, minChartData, maxChartData, e) {

        if (base != undefined &&
            base.plotBands != undefined &&
            minChartData != undefined &&
            maxChartData != undefined &&
            e != undefined) {

            if (base.plotBands.length != undefined) {

                // multiple plotbands/lines
                for (var p = 0; p < base.plotBands.length; p++) {                 // check all plotbands
                    if (base.plotBands[p].from == base.plotBands[p].to &&
                        base.plotBands[p].from >= minChartData && base.plotBands[p].from <= maxChartData) // check it is a plotline that we want
                    {
                        makePlotLine(base.name, e, base.plotBands[p]);
                    }
                }

            } else {

                // one plotband/line
                if (base.plotBands.from == base.plotBands.to &&
                    base.plotBands[p].from >= minChartData && base.plotBands[p].from <= maxChartData) // check it is a plotline that we want 
                {
                    makePlotLine(base.name, e, base.plotBands);
                }
            }
        }
    }


    function axisPlotLines(e, valaxis) {        

        // Get access to the axis (dynamic min and max not in the event (e) variable, use getAxis).
        var chrt = $(e.sender.wrapper[0]).data("kendoChart");

        if (chrt != undefined) {

            var axis = chrt.getAxis(valaxis.name);

            if (axis != undefined) {

                var minChartData = axis.options.min; // dynamic min by Kendo
                var maxChartData = axis.options.max; // dynamic max by Kendo

                // Check min max (static) values set in design
                var minSetting = valaxis.min;
                var maxSetting = valaxis.max;

                // Check if there is a setup of min/max value
                if (minSetting != undefined) minChartData = minSetting;
                if (maxSetting != undefined) maxChartData = maxSetting;

                printPlotLines(valaxis, minChartData, maxChartData, e);
            }
        }
    }


    return {  

        //initializeChart: function (guid) {
        //    // Temp fix zoom Start (2022 first update kendo)
        //    var local_chart = $("#" + guid + " > .k-chart").data("kendoChart");
        //    local_chart.bind("zoomStart", function (e) {
        //        e.preventDefault();
        //    });

        //    // Event handler ( outside the wrapper ? remove all chart tooltips in the page.)
        //    // Small delay added (finetune)
        //    $("#" + guid).hover(
        //        function () { },
        //        function () { setTimeout(function () { $('.k-chart-tooltip').remove(); }, 100); }
        //    );
        //},

        //refreshChart: function (periodSelectorID) {
        //    var charts = $("div[periodselectorid='" + periodSelectorID + "']");
        //    for (var i = 0; i < charts.length; i++) {
        //        var spltArray = charts[i].id.split('_');
        //        if (spltArray.length > 2) {
        //            var chartDefID = spltArray[2];
        //            if (chartDefID !== undefined) {
        //                if (chartDefID !== undefined) {
        //                    $("#PartialChartView_" + chartDefID).load("Charts/Chart?ChartDefID=" + chartDefID);
        //                }
        //            }
        //        }
        //    }
        //},

        onHighLightSampleChart: function (e) {},

        onSeriesHoverChart: function (e) {},

        onSeriesOverChart: function (e) {},

        onSeriesLeaveChart: function (e) {},

        //
        // Render is called after the chart is drawn. Anything added by the render function is placed on top of the chart.
        //
        onRenderChart: function (e) {

            if (e != undefined &&
                e.sender != undefined &&
                e.sender.options != undefined &&
                e.sender.options.valueAxis != undefined) {

                if (e.sender.options.valueAxis.length != undefined) {
                    for (var i = 0; i < e.sender.options.valueAxis.length; i++) {
                        // check all axes for plotbands (only one axis can have plotbands)
                        axisPlotLines(e, e.sender.options.valueAxis[i]);
                    }
                } else {
                    if (e.sender.options.valueAxis.plotBands != undefined) {
                        axisPlotLines(e, e.sender.options.valueAxis);
                    }
                }
            }
        },

        // a and b are javascript Date objects
        dateDiffInDays: function (a, b) {
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            var inputValidDateTimes = typeof a.getMonth === 'function' && typeof b.getMonth === 'function';

            if (inputValidDateTimes) {
                // Discard the time and time-zone information.
                const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
                const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

                return Math.floor((utc2 - utc1) / _MS_PER_DAY);
            }

            return 0;
        },
    
    }
}();